/*
* @Author: zhangzhitao
* @Date: 2019-05-20 11:36:58
* @Des:
 * @Last Modified by: yuzhou.zhou
 * @Last Modified time: 2020-06-18 16:56:16
*/

<template>
  <h-layout>
    <h-page-sidebar>
      <template slot="pageSidebarAction">
        <el-tooltip
          effect="light"
          :content="$t('management.menu.add')"
          placement="top"
        >
          <el-button
            type="iconButton"
            icon="h-icon-add"
            :disabled="activeNode.level>2&&activeTab!=='toolNav'||activeNode.level>1&&activeTab==='toolNav'"
            @click="dialogVisible=true"
          />
        </el-tooltip>
        <el-tooltip
          effect="light"
          :content="$t('management.menu.del')"
          placement="top"
        >
          <el-button
            type="iconButton"
            icon="h-icon-delete"
            :disabled="canNotDelete"
            @click="handleDeleteMenu"
          />
        </el-tooltip>
        <el-tooltip
          effect="light"
          :content="$t('management.menu.move_up')"
          placement="top"
        >
          <el-button
            type="iconButton"
            icon="h-icon-arrow_up"
            :disabled="canNotMove"
            @click="handleMoveUpDown('up')"
          />
        </el-tooltip>
        <el-tooltip
          effect="light"
          :content="$t('management.menu.move_up')"
          placement="top"
        >
          <el-button
            type="iconButton"
            icon="h-icon-arrow_down"
            :disabled="canNotMove"
            @click="handleMoveUpDown('down')"
          />
        </el-tooltip>
      </template>
      <template slot="pageSidebarSearch">
        <el-input
          v-model="menuSearchKey"
          :placeholder="$t('management.menu.menu_search_placeholder')"
          suffix-icon="h-icon-search"
          clearable
          :clear-icon-click="handleClearTree"
        />
      </template>
      <el-tree
        ref="areaTree"
        :data="menus"
        class="move-tree"
        node-key="id"
        :props="defaultProps"
        move
        :auto-expand-parent="false"
        :default-expanded-keys="defaultExpKeys"
        :filter-node-method="handleSearchTree"
        :before-drag="beforeDrag"
        :before-drop="beforeDrop"
        @node-click="handleNodeClick"
        @node-drag-end="handleNodeDragEnd"
        @node-expand="handleNodeExpand"
        @node-collapse="handleNodeCollapse"
      />
      <!-- <div
        class="m-empty"
        v-if="filterChildrenLength===0&&menus.length>0"
      >暂无数据</div> -->
    </h-page-sidebar>
    <h-layout direction="vertical">
      <h-page-content style="padding:0">
        <el-alert
          :title="alterWords"
          type="info"
          simple
          v-if="alterWords.length>0"
          show-icon
        ></el-alert>
        <el-form
          :model="menuForm"
          :rules="rules"
          ref="menuForm"
          label-position="top"
          style="width: 480px; margin: 40px auto 0;"
          content-width="480px"
        >
          <el-form-item
            :label="$t('management.menu.name_label')"
            prop="name"
            required-right
          >
            <el-input
              v-model="menuForm.name"
              :maxlength="16"
              :disabled="formDisabled"
              :placeholder="$t('management.menu.menu_name_placeholder')"
            />
          </el-form-item>
          <el-form-item
            :label="$t('management.menu.des_label')"
            prop="desc"
          >
            <el-input
              v-model="menuForm.desc"
              :disabled="formDisabled"
              :placeholder="$t('management.menu.des_placeholder')"
            />
          </el-form-item>
          <el-form-item
            :label="$t('management.menu.icon_label')"
            required-right
            prop="iconPath"
            v-if="(activeTab==='toolNav'&&activeNode.level===1)||(activeTab==='app'&&activeNode.level!==1)||(activeTab!=='toolNav'&&activeTab!=='app')"
            :rules="[{
          type: 'string',
          required: activeNode.level===1&&activeTab==='toolNav',
          message: $t('common.require_valid_error'),
          trigger: 'blur'
        }]"
          >
            <menu-icon-upload
              type="menuIcon"
              v-model="iconInfo"
              :disabled="formDisabled"
            >
            </menu-icon-upload>
          </el-form-item>
          <el-form-item
            :label="$t('management.menu.url_label')"
            prop="url"
            :rules="[{
          type: 'string',
          required: activeNode.level>2&&activeTab!=='toolNav'||activeNode.level>1&&activeTab==='toolNav',
          message: $t('common.require_valid_error'),
          trigger: 'blur'
        },noChinese,max255ChartRule]"
            required-right
          >
            <el-input
              v-model="menuForm.url"
              :disabled="formDisabled"
              :placeholder="$t('management.menu.menu_url_placeholder')"
            />
          </el-form-item>
          <el-form-item
            :label="$t('management.menu.open_way_label')"
            v-if="activeTab!=='config'&&activeTab!=='personal'"
            required-right
            prop="openType"
          >
            <el-select
              :disabled="formDisabled"
              v-model="menuForm.openType"
              :placeholder="$t('management.menu.please_select')"
            >
              <!-- <el-option
                :value="1"
                :label="$t('management.menu.open_type_name1')"
              ></el-option> -->
              <el-option
                :value="0"
                :label="$t('management.menu.open_type_name1')"
              ></el-option>
              <el-option
                :value="2"
                :label="$t('management.menu.open_type_name2')"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$t('management.menu.is_show')"
            required-right
          >
            <el-switch
              v-model="menuForm.isShow"
              :disabled="formDisabled"
            > </el-switch>
          </el-form-item>
          <el-form-item
            :label="$t('management.menu.relevance_data_view')"
            required-right
            v-if="menuForm.componentMenuId&&menuForm.componentMenuId.indexOf('display_board')>-1"
          >
            <el-select
              v-model="menuForm.displayBoardId"
              :placeholder="$t('management.menu.please_select')"
            >
              <el-option
                :label="$t('management.menu.null')"
                :value="null"
              ></el-option>
              <el-option
                v-for="item in displayBoards"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <h-page-group>
            <el-button
              type="primary"
              :disabled="cannotSave"
              @click="
              handleSave"
            >{{$t('common.save')}}</el-button>
          </h-page-group>
        </el-form>
      </h-page-content>
    </h-layout>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="$t('management.menu.dialog_title')"
      custom-class="no-padding auto-height"
      :area="515"
    >
      <menu-info
        v-if="dialogVisible"
        ref="menuInfo"
        :tabName="activeTab"
        :showToolLen="showToolLen"
        :activeNode="activeNode"
        :menus="menus"
      ></menu-info>
      <span slot="footer">
        <el-button
          type="primary"
          @click="finishOperate"
        >{{$t('common.confirmBtn_text')}}</el-button>
        <el-button @click="cancelOperate">{{$t('common.cancelBtn_text')}}</el-button>
      </span>
    </el-dialog>
  </h-layout>
</template>

<script>
import menuIconUpload from './menu-icon-upload'
import menuInfo from './menu-info'
import { ErrorHandleMixin, LoadingMixin } from 'utils/mixin'
import { charRule, allSpaceRule, max16ChartRule, requireRule, requireNumberRule, noChinese, max255ChartRule } from 'utils/validator'
import API from 'api/api'
export default {
  name: 'menu-wrap',
  props: {
    menus: {
      type: Array,
      default: () => {
        return []
      }
    },
    activeTab: {
      type: String,
      default: 'app'
    }
  },

  data () {
    return {
      max255ChartRule: max255ChartRule,
      noChinese: noChinese,
      // 筛选key值
      menuSearchKey: '',
      // 树默认属性重置
      defaultProps: {
        children: 'children',
        label: 'name',
        icon: 'no_icon'
      },
      // 菜单详情表单
      menuForm: {
        openType: '',
        isShow: true,
        displayBoardId: '',
        componentMenuId: ''
      },
      rules: {
        name: [requireRule, charRule, max16ChartRule, allSpaceRule],
        openType: [requireNumberRule],
        url: [noChinese]
      },
      iconInfo: {
        fileId: '-1',
        path: ''
      },
      // 菜单添加dialog
      dialogVisible: false,
      // 当前选中的节点node
      activeNode: {},
      // 用于解决迁移后又马上上下移动，获取不到node节点的parent的问题
      tempGoalNode: null,
      displayBoards: [],
      defaultPropsAuto: {
        value: 'id',
        label: 'name'
      },
      // 默认展开树节点
      defaultExpKeys: []
      // filterChildrenLength: 1
    }
  },

  components: { menuIconUpload, menuInfo },

  computed: {
    canNotDelete () {
      return (this.menuForm && this.menuForm.permissionCode !== 'extend_menu_permission' && this.activeTab !== 'toolNav') || (this.activeTab === 'toolNav' && !this.menuForm.id)
    },
    canNotMove () {
      return (this.menuForm && this.menuForm.permissionCode !== 'extend_menu_permission' && this.activeTab !== 'toolNav') || (this.activeTab === 'toolNav' && !this.menuForm.id) || this.menuSearchKey.length > 0
    },
    alterWords () {
      if (this.menuForm.children && this.menuForm.children.length > 0 && this.menuForm.url && this.menuForm.url.length > 0) {
        return this.$t('management.menu.menu_tips1')
      } else if ((!this.menuForm.children || (this.menuForm.children && this.menuForm.children.length === 0)) && this.activeNode.parent && this.activeNode.parent.data.url && this.activeNode.parent.data.url.length > 0) {
        return this.$t('management.menu.menu_tips2')
      } else if (this.activeTab === 'toolNav' && (!this.menuForm.children || (this.menuForm.children && this.menuForm.children.length === 0)) && !this.menuForm.url) {
        return this.$t('management.menu.menu_tips3')
      } else {
        return this.$t('management.menu.menu_tips4')
      }
    },
    formDisabled () {
      return !((this.menuForm.permissionCode === 'extend_menu_permission' && this.activeTab !== 'toolNav') || (this.menuForm.id && this.activeTab === 'toolNav'))
    },
    cannotSave () {
      if (this.menuForm.permissionCode !== 'extend_menu_permission' && this.activeTab !== 'toolNav') {
        if (this.menuForm.componentId && this.menuForm.componentId === 'isecure' && this.menuForm.componentMenuId && this.menuForm.componentMenuId.indexOf('display_board') > -1) {
          return false
        } else {
          return true
        }
      } else if (!this.menuForm.id && this.activeTab === 'toolNav') {
        return true
      } else {
        return false
      }
    },
    // 动态计算可展示的导航工具栏有几个
    showToolLen () {
      let tempArr = []
      this.menus.forEach(item => {
        if (item.isShow) {
          tempArr.push(item)
        }
      })
      return tempArr.length
    }
  },

  mounted () {
    this._getDisplayBoard()
  },

  methods: {
    handleNodeExpand (menu, node, self) {
      this.defaultExpKeys.push(menu.id)
    },
    handleNodeCollapse (menu, node, self) {
      for (let i = 0; i < this.defaultExpKeys.length; i++) {
        if (this.defaultExpKeys[i] === menu.id) {
          this.defaultExpKeys.splice(i, 1)
          break
        }
      }
    },
    // 关闭添加菜单dialog
    cancelOperate () {
      this.dialogVisible = false
    },
    // 筛选
    handleSearchTree (value, data) {
      return data.name.indexOf(value) !== -1
    },
    // 取消筛选
    handleClearTree () {
      this.menuSearchKey = ''
      this.handleSearchTree()
    },
    // 菜单节点click
    handleNodeClick (menu, node) {
      if (typeof menu.isShow === 'number') {
        menu.isShow = menu.isShow === 0
      }
      this.menuForm = JSON.parse(JSON.stringify(menu))
      this.activeNode = node
      this.tempGoalNode = null
      if (this.activeTab !== 'toolNav') {
        this.iconInfo = menu.iconInfo
      } else {
        this.iconInfo = {
          fileId: menu.icon || '-1',
          path: menu.iconPath || ''
        }
      }
    },

    // 拖拽前事件，同步的菜单不可拖拽
    beforeDrag (node) {
      if (node.permissionCode !== 'extend_menu_permission' && this.activeTab !== 'toolNav') return false
      return true
    },
    beforeDrop (menu, targetNode, movePosition) {
      return true
    },
    // 迁移结束时
    async handleNodeDragEnd (e, arr, node, goalNode, pos, self) {
      this.menuForm = node.data
      this.activeNode = node
      if (this.activeTab !== 'toolNav') {
        this.iconInfo = this.menuForm.iconInfo
      } else {
        this.iconInfo = {
          fileId: this.menuForm.icon || '-1',
          path: this.menuForm.iconPath || ''
        }
      }
      if (pos !== 'out') {
        let key = this.activeTab === 'toolNav' ? 'id' : 'menuId'
        if ((pos === 'inner' && node.childNodes.length > 0 && node.level <= goalNode.level) || (pos !== 'inner' && goalNode.level > node.level)) {
          this.$message.warning(this.$t('management.menu.menu_warning1'))
          this.$emit('refresh')
          return
        }
        if (pos === 'inner' && goalNode.level > 2 && this.activeTab !== 'toolNav') {
          this.$message.warning(this.$t('management.menu.menu_warning2'))
          this.$emit('refresh')
          return
        } else if (goalNode.level > 1 && this.activeTab === 'toolNav') {
          this.$message.warning(this.$t('management.menu.menu_warning3'))
          this.$emit('refresh')
          return
        }
        let parentId = pos === 'inner' ? goalNode.data[key] : goalNode.data.parentId
        this.tempGoalNode = pos === 'inner' ? goalNode : goalNode.parent
        let menuIds = pos === 'inner' ? goalNode.childNodes.map(item => item.data[key]) : goalNode.parent.childNodes.map(item => item.data[key])
        this._moveMenu(menuIds, parentId)
      }
    },
    // 菜单上下移
    handleMoveUpDown (dir) {
      let activeMenuId = this.activeTab !== 'toolNav' ? this.activeNode.data.menuId : this.activeNode.data.id
      let _nodes = this.tempGoalNode ? this.tempGoalNode.childNodes : this.activeNode.parent.childNodes
      let _menuIds
      _nodes.forEach((node, index) => {
        if (node.key === this.activeNode.key) {
          if (dir === 'up' && index === 0) {
            this.$message.warning(this.$t('management.menu.can_not_move_up'))
          } else if (dir === 'down' && index === _nodes.length - 1) {
            this.$message.warning(this.$t('management.menu.can_not_move_up'))
          } else {
            let menuIds = _nodes.map(node => {
              return this.activeTab !== 'toolNav' ? node.data.menuId : node.data.id
            })
            _menuIds = JSON.parse(JSON.stringify(menuIds))
            menuIds.forEach((menuId, j) => {
              if (menuId === activeMenuId) {
                if (dir === 'up') {
                  _menuIds[j] = _menuIds[j - 1]
                  _menuIds[j - 1] = activeMenuId
                } else if (dir === 'down') {
                  _menuIds[j] = _menuIds[j + 1]
                  _menuIds[j + 1] = activeMenuId
                }
              }
            })
            this._moveMenu(_menuIds, this.activeNode.data.parentId)
          }
        }
      })
    },
    // autocompelete的方法
    querySearch (queryString, cb) {
      let displayBoards = this.displayBoards
      let results = queryString
        ? displayBoards.filter(this.createFilter(queryString))
        : displayBoards
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter (queryString) {
      return displayBoards => {
        return displayBoards.name.indexOf(queryString.toLowerCase()) === 0
      }
    },

    // ===================请求=================================

    // 保存菜单
    handleSave () {
      this.$refs.menuForm.validate(async valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.menuForm))
          params['icon'] = this.iconInfo.fileId
          params['isShow'] = this.menuForm.isShow ? 0 : 1
          if (!params.menuId && !params.id) {
            this.$message.warning(this.$t('management.menu.has_not_select'))
            return false
          }
          let FN = this.activeTab === 'toolNav' ? 'editTool' : 'edit'
          API.menu[FN](params).then(res => {
            this.$message.success(this.$t('management.menu.update_success'))
            this.$emit('refresh')
          }).catch(() => {
            this.$emit('refresh')
          })
        }
      })
    },
    // 完成菜单配置（dialog）
    finishOperate () {
      let _result = this.$refs.menuInfo.getResult()
      if (!_result) return
      if (_result.parentId === -1 && this.activeTab !== 'toolNav') {
        _result.parentId = this.activeTab
      } else if (_result.parentId === -1 && this.activeTab === 'toolNav') {
        _result.parentId = ''
      }
      _result.isShow = _result.isShow ? 0 : 1
      this._addMenu(_result)
    },
    // 添加菜单
    _addMenu (params) {
      let _loadingInstance = this._getLoading()
      let addFn = this.activeTab === 'toolNav' ? 'addTool' : 'add'
      API.menu[addFn](params)
        .then(res => {
          _loadingInstance.close()
          this.$message.success(this.$t('management.menu.add_menu_success'))
          this.$emit('refresh')
          this.dialogVisible = false
        })
        .catch(() => {
          _loadingInstance.close()
        })
    },
    // 删除菜单
    handleDeleteMenu () {
      this.$confirm(this.$t('management.menu.del_menu_ask'), {
        confirmButtonText: this.$t('common.confirmBtn_text'),
        cancelButtonText: this.$t('common.cancelBtn_text'),
        type: 'question'
      }).then(() => {
        this._deleteMenu()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('common.cancel_del')
        })
      })
    },
    _deleteMenu () {
      let _loadingInstance = this._getLoading()
      let removeFn =
        this.activeTab === 'toolNav' ? 'removeTool' : 'remove'
      let ids =
        this.activeTab === 'toolNav'
          ? { idString: this.menuForm.id }
          : { menuIds: this.menuForm.menuId }
      API.menu[removeFn](ids)
        .then(res => {
          _loadingInstance.close()
          this.$message.success(
            this.$t('management.menu.delete_menu_success')
          )
          this.$emit('refresh')
          this.menuForm = {
            openType: '',
            isShow: true,
            displayBoardId: '',
            componentMenuId: ''
          }
          this.iconInfo = {
            fileId: -1,
            path: ''
          }
          this.activeNode = {}
        })
        .catch(() => {
          _loadingInstance.close()
        })
    },
    // 迁移菜单
    _moveMenu (menuIds, parentId) {
      let _loadingInstance = this._getLoading()
      let reOrderFn = this.activeTab === 'toolNav' ? 'reOrderTool' : 'reOrder'
      let params = {
        parentId: parentId
      }
      params[this.activeTab === 'toolNav' ? 'toolbarIds' : 'menuIds'] = menuIds.join(',')
      API.menu[reOrderFn](params)
        .then(res => {
          _loadingInstance.close()
          this.$message.success(this.$t('management.menu.reorder_success'))
          this.$emit('refresh')
          this.menuForm = {
            openType: '',
            isShow: true,
            displayBoardId: '',
            componentMenuId: ''
          }
          this.iconInfo = {
            fileId: -1,
            path: ''
          }
        })
        .catch(() => {
          this.$emit('refresh')
          _loadingInstance.close()
        })
    },
    // 获取可关联看板
    _getDisplayBoard () {
      API.dataView.getDataViewList().then(res => {
        this.displayBoards = res.data || []
      })
    }
  },
  mixins: [ErrorHandleMixin, LoadingMixin],
  watch: {
    menus: {
      handler () {
        if (this.menuForm.id) {
          this.$refs.areaTree.setCurrentKey(this.menuForm.id)
        }
      },
      deep: true
    },
    activeTab () {
      this.menuForm = {
        openType: '',
        isShow: true,
        displayBoardId: '',
        componentMenuId: ''
      }
      this.iconInfo = {
        fileId: '-1',
        path: ''
      }
      this.activeNode = {}
      this.menuSearchKey = ''
      // this.filterChildrenLength = 1
    },
    // 筛选菜单
    menuSearchKey (val) {
      this.$refs.areaTree.filter(val, !this.menuSearchKey)
    },
    'iconInfo.path' (val) {
      this.menuForm['iconPath'] = val
    },
    // 当form表单变化时，清空验证
    menuForm: {
      handler () {
        this.$refs.menuForm.resetValidates()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.m-empty {
  width: 215px;
  height: 60px;
  line-height: 60px;
  margin: 0 auto;
  text-align: center;
  color: #ccc;
}
</style>
